/*
 * «Indossato con / Worn with» (issue #697, 28/09/2026).
 * Aggiunta al carrello dei capi del look senza lasciare la PDP, con la Cart
 * AJAX API e la stessa notifica carrello del pulsante principale
 * (assets/product-form.js). Nessun listener touch: solo submit/change di
 * form nativi (tap, tastiera e lettori di schermo seguono il comportamento
 * standard del browser).
 */
if (!customElements.get('worn-with-list')) {
  customElements.define('worn-with-list', class WornWithList extends HTMLElement {
    connectedCallback() {
      this.status = this.querySelector('[data-worn-with-status]');
      this.addEventListener('submit', (evt) => {
        const form = evt.target.closest('[data-worn-with-form]');
        if (!form) return;
        evt.preventDefault();
        this.add(form);
      });
      this.addEventListener('change', (evt) => {
        if (evt.target.matches('[data-worn-with-size]')) this.hideMessage(evt.target.form);
      });
    }

    add(form) {
      const button = form.querySelector('[data-worn-with-add]');
      if (!button || button.getAttribute('aria-disabled') === 'true') return;

      const variantId = new FormData(form).get('id');
      if (!variantId) {
        this.showMessage(form, this.dataset.textSizeError);
        const select = form.querySelector('[data-worn-with-size]');
        if (select) select.focus();
        return;
      }

      this.hideMessage(form);
      this.setState(button, 'adding');

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = new FormData(form);
      if (cart) {
        body.append('sections', cart.getSectionsToRender().map((section) => section.id));
        body.append('sections_url', window.location.pathname);
        cart.setActiveElement(button);
      }

      fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.setState(button, 'idle');
            this.showMessage(form, response.description || this.dataset.textError);
            return;
          }
          this.setState(button, 'added');
          this.announce(form.dataset.productName);
          this.track(form, variantId, response);
          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);
        })
        .catch((error) => {
          console.error(error);
          this.setState(button, 'idle');
          this.showMessage(form, this.dataset.textError);
        });
    }

    setState(button, state) {
      const label = button.querySelector('[data-worn-with-label]');
      clearTimeout(button.wornWithTimer);
      // Non la classe `loading` del tema: rende il testo trasparente.
      button.classList.toggle('worn-with__add--adding', state === 'adding');
      button.classList.toggle('worn-with__add--added', state === 'added');
      if (state === 'adding') {
        button.setAttribute('aria-disabled', 'true');
        label.textContent = this.dataset.textAdding;
      } else if (state === 'added') {
        button.removeAttribute('aria-disabled');
        label.textContent = this.dataset.textAdded;
        button.wornWithTimer = setTimeout(() => this.setState(button, 'idle'), 3000);
      } else {
        button.removeAttribute('aria-disabled');
        label.textContent = this.dataset.textAdd;
      }
    }

    showMessage(form, text) {
      const message = form.querySelector('[data-worn-with-message]');
      if (!message) return;
      message.textContent = text;
      message.hidden = false;
    }

    hideMessage(form) {
      const message = form && form.querySelector('[data-worn-with-message]');
      if (!message) return;
      message.hidden = true;
      message.textContent = '';
    }

    announce(productName) {
      if (!this.status) return;
      this.status.textContent = (this.dataset.textAddedStatus || '').replace('[product]', productName || '');
    }

    /*
     * Origine della sezione per l'analisi. L'add_to_cart GA4 standard lo
     * emette già il pixel Google & YouTube su ogni aggiunta AJAX; qui si
     * pubblica un evento personalizzato per il custom pixel (cantiere #305,
     * fase 3) e un evento DOM per eventuali ascoltatori del tema. In ordine
     * l'origine resta sulla riga (proprietà nascosta _origine).
     */
    track(form, variantId, response) {
      const detail = {
        origine: this.dataset.origine,
        source_product_id: this.dataset.sourceProductId,
        product_id: form.dataset.productId,
        variant_id: String(variantId),
        price: typeof response.final_price === 'number' ? response.final_price / 100 : null,
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : null
      };
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('vietti_worn_with_add_to_cart', detail);
        }
      } catch (error) {
        console.error(error);
      }
      document.dispatchEvent(new CustomEvent('vietti:worn-with:add', { detail }));
    }
  });
}
